var _style, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFA6EE;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,0h34c5.5,0,10,4.5,10,10v34c0,5.5-4.5,10-10,10H10C4.5,54,0,49.5,0,44V10C0,4.5,4.5,0,10,0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M19.6,9.2c-1.9,0.1-3.2,0.4-4.3,0.8c-1.2,0.5-2.2,1.1-3.2,2.1c-1,1-1.6,2-2.1,3.2c-0.4,1.1-0.7,2.4-0.8,4.3 c-0.1,1.9-0.1,2.5-0.1,7.4c0,4.9,0,5.5,0.1,7.4c0.1,1.9,0.4,3.2,0.8,4.3c0.5,1.2,1.1,2.2,2.1,3.2c1,1,2,1.6,3.2,2.1 c1.1,0.4,2.4,0.7,4.3,0.8c1.9,0.1,2.5,0.1,7.4,0.1c4.9,0,5.5,0,7.4-0.1c1.9-0.1,3.2-0.4,4.3-0.8c1.2-0.5,2.2-1.1,3.2-2.1 c1-1,1.6-2,2.1-3.2c0.4-1.1,0.7-2.4,0.8-4.3c0.1-1.9,0.1-2.5,0.1-7.4c0-4.9,0-5.5-0.1-7.4c-0.1-1.9-0.4-3.2-0.8-4.3 c-0.5-1.2-1.1-2.2-2.1-3.2c-1-1-2-1.6-3.2-2.1c-1.1-0.4-2.4-0.7-4.3-0.8c-1.9-0.1-2.5-0.1-7.4-0.1C22.1,9.1,21.5,9.1,19.6,9.2  M19.8,41.6c-1.7-0.1-2.7-0.4-3.3-0.6c-0.8-0.3-1.4-0.7-2.1-1.3c-0.6-0.6-1-1.2-1.3-2.1c-0.2-0.6-0.5-1.6-0.6-3.3 c-0.1-1.9-0.1-2.5-0.1-7.2c0-4.8,0-5.3,0.1-7.2c0.1-1.7,0.4-2.7,0.6-3.3c0.3-0.8,0.7-1.4,1.3-2.1c0.6-0.6,1.2-1,2.1-1.3 c0.6-0.2,1.6-0.5,3.3-0.6c1.9-0.1,2.5-0.1,7.2-0.1c4.8,0,5.3,0,7.2,0.1c1.7,0.1,2.7,0.4,3.3,0.6c0.8,0.3,1.4,0.7,2.1,1.3 c0.6,0.6,1,1.2,1.3,2.1c0.2,0.6,0.5,1.6,0.6,3.3c0.1,1.9,0.1,2.5,0.1,7.2c0,4.8,0,5.3-0.1,7.2c-0.1,1.7-0.4,2.7-0.6,3.3 c-0.3,0.8-0.7,1.4-1.3,2.1c-0.6,0.6-1.2,1-2.1,1.3c-0.6,0.2-1.6,0.5-3.3,0.6c-1.9,0.1-2.5,0.1-7.2,0.1 C22.2,41.7,21.7,41.7,19.8,41.6 M34.4,17.4c0,1.2,1,2.1,2.2,2.1c1.2,0,2.1-1,2.1-2.2c0-1.2-1-2.1-2.2-2.1 C35.3,15.3,34.4,16.2,34.4,17.4 M17.8,27c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2c0-5.1-4.1-9.2-9.2-9.2 C21.9,17.8,17.8,21.9,17.8,27 M21,27c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6c0,3.3-2.7,6-6,6C23.7,33,21,30.3,21,27"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023247938153561019880000008762760397708009379_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.fd2133d4ace1a1f29c0cca0f9d24be78.svg";
export { ForwardRef as ReactComponent };